export default function PropertiesIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="10"
        y="10.35"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="12.5"
        fontWeight="900"
        fontFamily="Inter, sans-serif"
      >
        P
      </text>
    </svg>
  );
}
